<!--  -->
<template>
  <div class="list-container">
    <div class="list-form">
      <a-form ref="listForm">
        <div class="form-body">
          <div class="form-item1">
            <a-form-item label="活动名称" class="item">
              <a-input v-model:value="modelRef.name" placeholder="请输入活动名称" allowClear />
            </a-form-item>
            <a-form-item label="发布状态" class="item">
              <a-select v-model:value="modelRef.status">
                <a-select-option
                  :value="item.text"
                  v-for="(item,index) in statusOption"
                  :key="index"
                >{{item.text}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="创建时间" class="item">
              <a-range-picker
                v-model:value="modelRef.time"
                class="item"
                show-time
                :placeholder="['开始时间', '结束时间']"
              >
                <template #dateRender="{ current, today }">
                  <div class="ant-calendar-date">{{ current.date() }}</div>
                </template>
              </a-range-picker>
            </a-form-item>
          </div>
        </div>
      </a-form>
    </div>
    <div class="list-btn">
      <a-button type="primary" @click="searchBtn('click')" :loading="loadingSearch">查询</a-button>
    </div>
    <div class="list-body">
      <div class="create-btn">
        <a-button type="primary" @click="showModel(1,'创建活动')" v-if="createBtn">创建活动</a-button>
      </div>
      <a-list item-layout="vertical" size="large" :data-source="listData">
        <template #renderItem="{ item }">
          <a-list-item key="item.title">
            <template #actions>
              <div class="a-list-action">
                <div class="action-item">
                  <span v-for="{ type, text,id } in actions" :key="type" class="list-span">
                    <span
                      v-if="id === 0 && item.createTemplateRole && item.activitiesNodes.length === 0"
                      class="list-span"
                    >
                      <Icon :icon="type" />
                      <span @click="jumpToStencil(item)">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>
                    <!--配置规则-->
                    <span v-if="id === 6 && item.type!==0" class="list-span">
                      <Icon :icon="type" />
                      <span @click="jumpToRules(item)" v-if="id === 6">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>
                    <!---->
                    <!--删除-->
                    <span v-if="id === 7" class="list-span">
                      <Icon :icon="type" />
                      <span @click="deleteListItem(item)" v-if="id === 7">{{ text }}</span>
                      <!-- <a-divider type="vertical" /> -->
                    </span>
                    <!---->
                    <span
                      v-if="id === 5 && item.createTemplateRole && item.activitiesNodes.length !== 0"
                      class="list-span"
                    >
                      <Icon :icon="type" />
                      <span @click="jumpToStencil(item)">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>

                    <span v-if="id === 2 && item.listCopyRole" class="list-span">
                      <Icon :icon="type" />
                      <span @click="showModel(3,'复制创建',item)">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>
                    <span
                      v-if="id === 3 && item.listPublishRole && item.status===2"
                      class="list-span"
                    >
                      <Icon :icon="type" />
                      <span @click="showModel(4,'取消发布',item)">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>
                    <span
                      v-if="id === 4 && item.listPublishRole && item.status===1"
                      class="list-span"
                    >
                      <Icon :icon="type" />
                      <span @click="showModel(5,'发布',item)">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>
                    <span v-if="id === 1" class="list-span">
                      <Icon :icon="type" />
                      <span @click="jumpToConfig(item)" v-if="id === 1">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>
                    <span v-if="id === 8" class="list-span">
                      <Icon :icon="type" />
                      <span @click="downLoadFileChange(item)">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>
                    <span v-if="id === 9" class="list-span">
                      <Icon :icon="type" />
                      <span @click="uploadFileChange(item)">{{ text }}</span>
                      <a-divider type="vertical" />
                    </span>
                  </span>
                </div>
                <a-button
                  type="primary"
                  style="margin-right: -21px;"
                  @click="jumpToData(item)"
                  v-if="item.type !==0"
                >数据查询</a-button>
              </div>
            </template>
            <a-list-item-meta>
              <template #title>
                <div class="title-body">
                  <div class="a-list-title">
                    <p style="text-align: left">
                      {{item.name}}
                      <Icon :icon="'edit-line'" @click="showModel(2,'修改活动',item)" />
                    </p>
                    <span class="title-right red" v-if="item.status === 1">未发布</span>
                    <span class="title-right green" v-if="item.status === 2">已发布</span>
                  </div>
                  <div class="title-tag">
                    <a-tag color="orange">活动ID:{{item.activityId}}</a-tag>
                    <a-tag color="purple">创建时间:{{item.date}}</a-tag>
                  </div>
                </div>
              </template>
            </a-list-item-meta>
          </a-list-item>
        </template>
        <a-pagination
          :total="pageTotal"
          :pageSize="5"
          class="list-pagination"
          v-model:current="pageNumber"
          @change="pageChange"
        />
      </a-list>
    </div>
    <a-modal
      v-model:visible="modelVisible"
      :title="modelTitle"
      @ok="handleOk"
      @cancel="handelCancel"
      cancelText="取消"
      :confirmLoading="createModel.loading"
      okText="确定"
    >
      <div v-if="createModelState">
        <p v-if="createModel.modelStatus === 3">已复制创建活动名称：'{{currentItem.name}}'，请修改复制创建后的标题</p>

        <a-input-search
          v-model:value="createModel.name"
          :placeholder="modelPlaceholder"
          :maxlength="30"
          :loading="createModel.searchLoading"
          @change="nameChange"
        />
        <span class="errorSpan" v-if="createModel.error">活动名称已存在</span>
        <span class="errorSpan" v-if="createModel.emptyError">请输入活动名称</span>
      </div>
      <!--取消发布-->
      <div v-if="createModel.modelStatus === 4">
        <p>确定取消发布吗？</p>
      </div>
      <!--发布-->
      <div v-if="createModel.modelStatus === 5">
        <p>确定发布吗？</p>
      </div>
    </a-modal>
    <a-modal
      v-model:visible="deleteVisible"
      title="删除"
      @ok="handelDelete"
      cancelText="取消"
      okText="确定"
    >
      <p>确定删除吗？</p>
    </a-modal>
    <a-modal
      v-model:visible="uploadVisible"
      title="上传配置"
      @ok="uploadHandleOk"
      cancelText="取消"
      okText="确定"
    >
      <a-upload-dragger
        v-model:file-list="fileList"
        name="file"
        :multiple="false"
        method="post"
        :action="`/api/activities/import/${currentActive?.id}`"
        @change="uploadHandleChange"
      >
        <p class="ant-upload-drag-icon">
          <inbox-outlined></inbox-outlined>
        </p>
        <p class="ant-upload-text">点击或将文件拖拽到这里上传</p>
        <p class="ant-upload-hint">上传后会覆盖之前配置</p>
        <p class="ant-upload-hint">支持扩展名：.json</p>
      </a-upload-dragger>
    </a-modal>
  </div>
  <router-view />
</template>

<script>
// 导入的其他文件 例如：import moduleName from 'modulePath';
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  computed,
  onMounted,
  watch
} from "vue";
import { useRouter, useRoute } from "vue-router";
import Icon from "@/layout/icon";
import { message } from "ant-design-vue";
import DayJs from "dayjs";
import {
  StarOutlined,
  LikeOutlined,
  MessageOutlined,
  InboxOutlined
} from "@ant-design/icons-vue";
import {
  activitiesCreate,
  activitiesList,
  editActiveName,
  activeStatus,
  activitiesCopy,
  activitiesDelete,
  activeExport
} from "@/api/index.js";
import { useStore } from "vuex";
import { downLoadJSON } from "@/utils/index";
import moment from "moment";
export default defineComponent({
  components: {
    StarOutlined,
    LikeOutlined,
    MessageOutlined,
    Icon,
    InboxOutlined
  },
  setup(props, { attrs, slots, emit }) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    let gameCodeRef = computed(() => {
      return store.state.settings.currentGamgeCode;
    });
    const rolesList = computed(() => {
      return store.state.settings.roles;
    });
    let createModelState = computed(() => {
      if (
        state.createModel.modelStatus === 0 ||
        state.createModel.modelStatus === 1 ||
        state.createModel.modelStatus === 3 ||
        state.createModel.modelStatus === 2
      ) {
        return true;
      }
    });
    const state = reactive({
      uploadVisible: false,
      fileList: [],
      currentActive: null,
      statusOption: [
        {
          id: 0,
          text: "全部"
        },
        {
          id: 1,
          text: "未发布"
        },
        {
          id: 2,
          text: "已发布"
        }
      ],
      loadingSearch: false,
      modelVisible: false,
      modelTitle: "创建活动",
      modelPlaceholder: "请输入创建的名称",
      createModel: {
        name: null,
        loading: false,
        hasName: ["222", "333", "555"],
        searchLoading: false,
        error: false,
        emptyError: false,
        modelStatus: 0
      },
      listData: [],
      createTemplateRole: false,
      createBtn: false,
      listCopyRole: false,
      listPublishRole: false,
      currentItem: null,
      pageNumber: 1,
      pageTotal: 0,
      deleteVisible: false,
      currentItemList: null
    });

    // 表单model值
    const modelRef = reactive({
      name: null,
      status: "全部",
      time: null
    });
    // a-list配置
    const pagination = {
      pageSize: 5
    };
    const actions = [
      {
        id: 0,
        type: "add-box-line",
        text: "创建模版"
      },
      {
        id: 5,
        type: "edit-box-line",
        text: "编辑模版"
      },
      {
        id: 6,
        type: "ruler-line",
        text: "配置规则"
      },
      {
        id: 1,
        type: "file-code-line",
        text: "素材配置"
      },
      {
        id: 2,
        type: "file-copy-line",
        text: "复制创建"
      },
      {
        id: 8,
        type: "folder-download-line",
        text: "下载配置"
      },
      {
        id: 9,
        type: "folder-upload-line",
        text: "上传配置"
      },
      {
        id: 3,
        type: "close-circle-fill",
        text: "取消发布"
      },

      {
        id: 4,
        type: "send-plane-line",
        text: "发布"
      },
      {
        id: 7,
        type: "delete-bin-5-line",
        text: "删除"
      }
    ];
    // 事件
    const pageChange = (page, pageSize) => {
      console.log(page, pageSize, "pageSize");
      searchBtn();
    };
    const searchBtn = text => {
      if (text) {
        state.loadingSearch = true;
        state.pageNumber = 1;
      }
      let params = {
        productId: route.query.id,
        gameCode: gameCodeRef.value,
        status: state.createModel.status,
        pageSize: 5,
        pageNumber: state.pageNumber
      };
      if (modelRef.time && modelRef.time.length > 0) {
        params.beginTime = moment(modelRef.time[0]).unix();
        params.endTime = moment(modelRef.time[1]).unix();
      }
      if (modelRef.name) {
        params.name = modelRef.name;
      }
      if (modelRef.status) {
        params.status =
          modelRef.status === "全部" ? 0 : modelRef.status === "未发布" ? 1 : 2;
      }
      activitiesList(params).then(res => {
        console.log(res, "res");
        if (res.status === 200) {
          setTimeout(() => {
            state.loadingSearch = false;
          }, 2000);
          state.createModel.hasName = res.data.activitiesMetas.map(item => {
            return {
              name: item.name
            };
          });
          state.pageTotal = res.data.total;
          res.data.activitiesMetas.forEach(item => {
            item.date = DayJs(item.createdAt * 1000).format(
              "YYYY/MM/DD HH:mm:ss"
            );
            console.log(item, "00000");
            if (state.createTemplateRole) {
              item.createTemplateRole = true;
            }
            if (state.listCopyRole) {
              item.listCopyRole = true;
            }
            if (state.listPublishRole) {
              item.listPublishRole = true;
            }
          });
          console.log(res.data.activitiesMetas, "res.data.activitiesMetas");
          state.listData = res.data.activitiesMetas;
        }
      });
    };
    const showModel = (status, name, item) => {
      state.createModel.emptyError = false;
      state.modelVisible = true;
      state.modelTitle = name;
      state.createModel.modelStatus = status;
      state.modelTitle = name;
      state.currentItem = item;
      console.log(item, "itemitemitemitem");
      if (status === 2) {
        state.modelPlaceholder = "请输入修改的名称";
        state.createModel.name = item.name;
      }
    };
    const handleOk = e => {
      switch (state.createModel.modelStatus) {
        case 1:
          createActiveChange();
          break;
        case 2:
          editNameChange();
          break;
        case 3:
          copyCreate();
          break;
        case 4:
          releaseStatus();
          break;
        case 5:
          releaseStatus();
          break;
      }
    };
    // 复制创建
    const copyCreate = () => {
      if (!state.createModel.name) {
        state.createModel.emptyError = true;
        return;
      }
      state.createModel.loading = true;
      let params = {
        name: state.createModel.name
      };
      activitiesCopy(params, state.currentItem.id).then(res => {
        console.log(res, "uoieouoweuo");
        if (res.status === 200) {
          setTimeout(() => {
            state.createModel.loading = false;
            state.modelVisible = false;
            message.success("复制创建成功！");
            resetForm();
            searchBtn();
          }, 2000);
        }
      });
    };
    // 发布和取消发布
    const releaseStatus = () => {
      state.createModel.loading = true;
      let params = {
        status: state.currentItem.status === 1 ? 2 : 1
      };
      activeStatus(params, state.currentItem.id).then(res => {
        console.log(res, "yyyreere");
        if (res.status === 200) {
          setTimeout(() => {
            state.createModel.loading = false;
            state.modelVisible = false;
            if (state.currentItem.status === 1) {
              message.success("发布成功！");
            }
            if (state.currentItem.status === 2) {
              message.success("取消发布成功！");
            }
            resetForm();
            searchBtn();
          }, 2000);
        }
      });
    };
    // 修改活动名称
    const editNameChange = () => {
      if (!state.createModel.name) {
        state.createModel.emptyError = true;
        return;
      }
      if (state.createModel.error) return;

      state.createModel.loading = true;
      let params = {
        name: state.createModel.name
      };
      editActiveName(params, state.currentItem.id)
        .then(res => {
          console.log(res, "resres");
          if (res.status === 200) {
            setTimeout(() => {
              state.createModel.loading = false;
              state.modelVisible = false;
              message.success("修改成功！");
              resetForm();
              searchBtn();
            }, 2000);
          }
        })
        .catch(error => {
          console.log(error, "error");
          const { response } = error;
          if (response.data.exception.error_code === 400401) {
            message.error("活动名称已存在");
            resetForm();
            state.createModel.loading = false;
            state.modelVisible = false;
          }
        });
    };
    // 创建活动
    const createActiveChange = () => {
      console.log(gameCodeRef, state.createModel.name, "gameCodeRef");
      if (!state.createModel.name) {
        state.createModel.emptyError = true;
        return;
      }
      state.createModel.loading = true;
      let params = {
        gameCode: gameCodeRef.value,
        productId: route.query.id,
        name: state.createModel.name
      };
      console.log(params, "hhdhd");
      activitiesCreate(params)
        .then(res => {
          console.log(res, "res");
          if (res.status == 200) {
            setTimeout(() => {
              state.createModel.loading = false;
              state.modelVisible = false;
              message.success("创建成功！");
              resetForm();
              searchBtn();
            }, 2000);
          }
        })
        .catch(error => {
          console.log(error, "error");
          if (error.response) {
            console.log(error.response, "error");
            let code = error.response.data.exception.error_code;
            if (code === 400401) {
              setTimeout(() => {
                state.createModel.loading = false;
                state.modelVisible = false;
                resetForm();
                message.error("创建失败，活动名字重复！");
              }, 2000);
            }
          }
        });
    };
    const resetForm = () => {
      state.createModel.name = null;
      state.createModel.error = false;
    };
    const handelCancel = () => {
      state.createModel.name = null;
    };
    const nameChange = value => {
      state.createModel.name = state.createModel.name.replace(/\s/g, "");
      state.createModel.searchLoading = true;
      if (state.createModel.name) {
        state.createModel.emptyError = false;
      }
      setTimeout(() => {
        state.createModel.searchLoading = false;
      }, 2000);
    };
    const checkName = () => {
      let findName = state.createModel.hasName.find(
        item => item.name === state.createModel.name
      );
      if (findName) {
        state.createModel.error = true;
      } else {
        state.createModel.error = false;
      }
    };
    const checkRoles = () => {
      console.log(rolesList, "rolesListrolesList");
      let createTemplateRole = rolesList.value.ROLE_TYPE_ACTIVITIES_LIST_CREATE_TEMPLATE.find(
        item => item === gameCodeRef.value
      );
      let listCopyRole = rolesList.value.ROLE_TYPE_ACTIVITIES_LIST_COPY.find(
        item => item === gameCodeRef.value
      );
      let listPublishRole = rolesList.value.ROLE_TYPE_ACTIVITIES_LIST_PUBLISH.find(
        item => item === gameCodeRef.value
      );
      let createBtn = rolesList.value.ROLE_TYPE_ACTIVITIES_LIST_CREATE_TEMPLATE.find(
        item => item === gameCodeRef.value
      );
      console.log(createTemplateRole, "createTemplateRole");
      if (createTemplateRole) {
        state.createTemplateRole = true;
      }
      if (createBtn) {
        state.createBtn = createBtn;
      }
      if (listCopyRole) {
        state.listCopyRole = true;
      }
      if (listPublishRole) {
        state.listPublishRole = true;
      }
    };
    const jumpToData = item => {
      router.push({
        name: "dataTable",
        query: { id: item.id, type: item.type }
      });
    };

    const jumpToRules = item => {
      console.log(item, "iiii");
      let query = {
        id: item.id,
        type: item.type
      };
      if (item.rulesStatus === 1) {
        query.isDetail = true;
      }
      router.push({
        name: "rulesConfig",
        query
      });
    };
    const jumpToStencil = item => {
      console.log(item, "item");
      let query = {
        id: item.id
      };
      if (item.activitiesNodes.length > 0) {
        query.isDetail = true;
      }
      if (item.type !== 0) {
        query.type = item.type;
      }
      if (item.status === 2) {
        query.status = item.status;
      }
      router.push({
        name: "listStencil",
        query
      });
    };
    const jumpToConfig = item => {
      let query = {
        id: item.id
      };
      router.push({
        name: "listConfig",
        query
      });
    };
    const handelDelete = async () => {
      try {
        await activitiesDelete({}, state.currentItemList.id);
        message.success("删除成功");
        searchBtn();
      } catch (error) {
        const { response } = error;
        console.log(response, "response");
        message.error("已发布的不可以删除");
      }
      state.deleteVisible = false;
    };
    const deleteListItem = item => {
      state.deleteVisible = true;
      state.currentItemList = item;
    };

    const downLoadFileChange = async item => {
      console.log(item, "item");
      state.currentActive = item;
      const res = await activeExport(item.id);
      console.log(res, "rererer");
      downLoadJSON(res.data, gameCodeRef.value, item.name);
    };
    const uploadFileChange = async item => {
      state.uploadVisible = true;
      state.currentActive = item;
    };
    const uploadHandleOk = () => {
      state.uploadVisible = false;
      searchBtn();
    };
    const uploadHandleChange = file => {
      console.log(file, "filefillll");
    };
    watch(
      () => state.uploadVisible,
      (uploadVisible, pre) => {
        if (!uploadVisible) {
          state.fileList = [];
        }
      }
    );
    // model事件
    watch(
      [gameCodeRef, rolesList],
      ([newGameCode, newRolesList], [preGameCode, preRolesList]) => {
        console.log(newGameCode, "newGameCode");
        if (newGameCode) {
          searchBtn();
        }
        if (newRolesList) {
          checkRoles();
        }
      }
    );
    onMounted(() => {
      if (gameCodeRef.value) {
        searchBtn();
        checkRoles();
      }
    });
    return {
      modelRef,
      ...toRefs(state),
      searchBtn,
      actions,
      pagination,
      showModel,
      handleOk,
      handelCancel,
      nameChange,
      jumpToStencil,
      jumpToConfig,
      jumpToRules,
      jumpToData,
      createModelState,
      pageChange,
      deleteListItem,
      handelDelete,
      downLoadFileChange,
      uploadFileChange,
      uploadHandleOk,
      uploadHandleChange
    };
  }
});
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.errorSpan {
  color: #f56c6c;
  font-weight: 500;
  padding-top: 5px;
}
.list-pagination {
  #flex-box.row-e();
}
@import "./index.less";
</style>